const DEVICE_KEY = 'ai-voice-device-id';

export function getDeviceId(): string {
  let value = localStorage.getItem(DEVICE_KEY);
  if (!value) {
    value = crypto.randomUUID().replaceAll('-', '');
    localStorage.setItem(DEVICE_KEY, value);
  }
  return value;
}

export function getSavedNickname(): string {
  return localStorage.getItem('ai-voice-nickname')?.trim() ?? '';
}

export function saveNickname(nickname: string): void {
  localStorage.setItem('ai-voice-nickname', nickname.trim());
}
